/**
 * Lab Flag Final Trust Indicator / Score helpers.
 */

export type FraudScore = {
  trustScore: number | null
  playerScore: number | null
}

/** Lab: trustScore 0 → red, 100 → green, else dash. */
export function trustIndicatorTone(
  trustScore: number | null | undefined,
): 'red' | 'green' | 'none' {
  if (trustScore === 0) return 'red'
  if (trustScore === 100) return 'green'
  return 'none'
}

export function formatPlayerScore(playerScore: number | null | undefined): string {
  if (playerScore == null || Number.isNaN(playerScore)) return '—'
  return String(playerScore)
}

/** Unique non-empty usernames, capped at page size. */
export function uniqueUsernames(names: string[], max = 100): string[] {
  const seen = new Set<string>()
  const out: string[] = []
  for (const raw of names) {
    const id = raw.trim()
    if (!id) continue
    const key = id.toLowerCase()
    if (seen.has(key)) continue
    seen.add(key)
    out.push(id)
    if (out.length >= max) break
  }
  return out
}
